import { currentHostFrameContext } from '@databases/database-state/state/host-frame-context';
import { useCallback } from 'react';
import { useSnapshot } from 'valtio';

import { useDisplayPasteFlags } from './useDisplayPasteFlags';

/**
 * This provides a function called `attemptCopy` that takes a callback. The callback will be called if the user
 * has proper DSP permissions. If the user does not, it will display a flag.
 */
export const useCopyWithDsp = () => {
  const frameContext = useSnapshot(currentHostFrameContext);
  const isExportDisabledByDSP = frameContext.data.dataSecurityPolicy?.pageExport !== true;
  const showFlags = useDisplayPasteFlags(undefined);

  const attemptCopy = useCallback(
    (callback: (...args: any[]) => void, isAttachmentSelected: boolean) => {
      if (isExportDisabledByDSP && isAttachmentSelected) {
        showFlags([
          {
            actionType: 'restrictedContentCantBeCopied',
            type: 'warning',
          },
        ]);
      } else {
        callback();
      }
    },
    [isExportDisabledByDSP, showFlags]
  );

  return { attemptCopy };
};
